import {persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';

import types, {partnersReducerKey} from './types';
import {Action, handleAsyncActions} from '../helpers';

export const partnersInitialState = {
   isFetching: false,
   error: null,
   // partners: {} as Partners, // TODO need to replace from layout reducer
};

const reducer = (_state = partnersInitialState, action: Action) => {
   const state = handleAsyncActions(_state, action, types);

   switch (action.type) {
      default:
         return state;
   }
};

let _reducer = reducer;
if (process.env.REACT_APP_PERSISTED === 'true') {
   const config = {
      key: partnersReducerKey,
      storage: storage,
      blacklist: ['error', 'isFetching'],
   };
   _reducer = persistReducer(config, reducer) as any;
}
export default _reducer;
